// extracted by mini-css-extract-plugin
module.exports = {"assignBtn":"_391WMgPISPZ7CvNQvv84vT","icon":"_3RascJiQuSsjkINKzaTuUS"};